/**
 * PublicHeader — Lightweight header for unauthenticated pages (login, signup, etc.)
 * Shows brand + theme toggle only. No sidebar, no user menu.
 */

import { Sun, Moon, Monitor } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTheme } from '../ThemeProvider';

export function PublicHeader() {
  const { mode, setMode, actualMode } = useTheme();

  const cycleTheme = () => {
    const next = mode === 'light' ? 'dark' : mode === 'dark' ? 'system' : 'light';
    setMode(next);
  };

  const ThemeIcon = mode === 'system' ? Monitor : actualMode === 'dark' ? Moon : Sun;

  return (
    <header
      className="sticky top-0 z-40 flex h-14 items-center gap-4 border-b border-border px-4 md:px-6"
      style={{
        backgroundColor: 'hsl(var(--header-background))',
        color: 'hsl(var(--header-foreground))',
      }}
    >
      {/* Brand — links to home */}
      <Link
        to="/"
        className="flex items-center gap-2 hover:opacity-80 transition-opacity"
      >
        <img
          src="/icons/HighCallRodeo-icon-white.png"
          alt=""
          className="h-[25px] w-auto"
        />
        <span className="text-sm font-semibold tracking-[0.15em] uppercase">
          HighCall Rodeo
        </span>
      </Link>

      {/* Spacer */}
      <div className="flex-1" />

      {/* Theme toggle */}
      <button
        onClick={cycleTheme}
        className="inline-flex items-center justify-center rounded-md p-2 opacity-60 hover:opacity-100 transition-opacity"
        aria-label={`Theme: ${mode}`}
        title={mode === 'system' ? `System (${actualMode})` : mode}
      >
        <ThemeIcon className="h-4 w-4" />
      </button>
    </header>
  );
}
